module.exports = __webpack_public_path__ + "img/facebook.dad14d0d.svg";